// react
import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { useNavigate } from 'react-router-dom';

// utils
import {
    tags_transformer,
    get_page_reset,
    add_params_to_uri
} from 'commons/utils';

// confs
import _app_conf from 'conf/app';

// components
import InlineOptions from './inline_options';

export default function FilterMenu(props)
{
    
    const navigate = useNavigate();
    const default_state =
    {
        tag: _app_conf.qa_filters.tags.default.id,
        sort_by: props.sort_by_items.meta.default,
        question: props.questions_items.meta.default
    };

    const question_default_value = props.current_order_by || default_state.question;
    const sort_by_default_value = props.current_sort_by || default_state.sort_by;

    // state management
    const [sort_by, set_sort_by] = useState(sort_by_default_value);
    const [order_by, set_order_by] = useState(question_default_value);
    const [cur_tag, set_cur_tag] = useState(props.current_tag);


    const on_change_order_by = (evt) =>
    {
        set_order_by(evt.target.value);
    };
    const on_change_sort_by = (evt) =>
    {
        set_sort_by(evt.target.value);
    };

    const on_change_tag = (item) =>
    {
        set_cur_tag(item.id);
    };

    const on_apply = () =>
    {
        // collect current status of entire components
        const stauts = {
            tag: cur_tag || '',
            sort_by: sort_by || '',
            order_by: order_by || ''
        }
        const data = add_params_to_uri({
            filters: {
                order_by: stauts.order_by,
                sort_by: stauts.sort_by,
                tag: stauts.tag
            }
        });
        navigate(data.url);
    };

    const on_reset = () =>
    {
        navigate(get_page_reset());
    };

    const get_full_tag_from_id = (id) =>
    {
        const tmp = props.tags.filter(obj => obj.id === id);
        if(tmp.length > 0)
        {
            const obj = tmp[0];
            return {
                'id': obj.id,
                'label': obj.name,
                'value': obj.id
            }
        }
        else return _app_conf.qa_filters.tags.default;
    };

    const formatter_for_group = (data) =>
    (
        <div className="group_styles">
            <span>{data.label}</span>
            <span className="group_badge_styles">{data.options.length}</span>
        </div>
    );

    const DebugState = ({show}) =>
    {
        if(!show) return <></>
        return (
            <div>
                <h2>state</h2>
                <div>
                    <h3>from props</h3>
                    <ul>
                        <li key="1">current tag: {JSON.stringify(props.current_tag)} </li>
                        <li key="2">current current order by: {JSON.stringify(props.current_order_by)} </li>
                        <li key="3">current sort by: {JSON.stringify(props.current_sort_by)} </li>
                    </ul>
                    <h4>from state</h4>
                    <ul>
                        <li key="1">current tag: {JSON.stringify(cur_tag)} </li>
                        <li key="2">current current order by: {JSON.stringify(order_by)} </li>
                        <li key="3">current sort by: {JSON.stringify(sort_by)} </li>
                    </ul>
                </div>
            </div>
        );
    }

    useEffect(() =>
    {
        set_cur_tag(props.current_tag);
        set_order_by(props.current_order_by);
        set_sort_by(props.current_sort_by);
    }, [props.current_tag, props.current_order_by, props.current_sort_by]);

    if (props.show)
    {
        const tag_default_value = get_full_tag_from_id(cur_tag) || _app_conf.qa_filters.tags.default;
        return (
            <>
                <div id="filters-options">
                    <div id="filters-options-body">
                        <div>
                            <h5>Filter by tag</h5>
                            <Select
                                    className='filters-options-select'
                                    options={tags_transformer.get_options_from_tags(props.tags)}
                                    onChange={on_change_tag}
                                    value={tag_default_value}
                                    formatGroupLabel={formatter_for_group}
                                />
                        </div>

                        <div>
                            <h5>{props.questions_items.meta.title}</h5>
                            <div>
                            {props.questions_items.data.map(item =>
                                (
                                    <InlineOptions
                                        key={item.id}
                                        value={item.id}
                                        name="question"
                                        label={item.label}
                                        default={order_by}
                                        onChange={on_change_order_by}
                                    />
                                ))}
                            </div>
                        </div>

                        <div>
                            <h5>{props.sort_by_items.meta.title}</h5>
                            <div>
                            {props.sort_by_items.data.map(item =>
                                (
                                    <InlineOptions
                                        key={item.id}
                                        value={item.id}
                                        name="sort_by"
                                        label={item.label}
                                        default={sort_by}
                                        onChange={on_change_sort_by}
                                    />
                                ))}
                            </div>
                        </div>

                    </div>

                    <div id="filters-options-footer">
                        <button onClick={on_reset} className="button button-discreet button-small"><i className="fa-solid fa-trash"></i> Reset All</button>
                        <button onClick={on_apply} className="button button-primary button-small"><i className="icon-checkmark"></i> Apply Filters</button>
                    </div>
                </div>
            </>
        );
    }
    else
    {
        return (<></>)
    }
}